import apiFetch from './client';

export function getTags() {
  return apiFetch('/api/tags/');
}

export function createTag(data) {
  return apiFetch('/api/tags/', { method: 'POST', body: JSON.stringify(data) });
}
